import { Dialog } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const LandingModalDialog = withStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    borderRadius: '8px',
  },
  paperFullScreen: {
    borderRadius: '8px 8px 0 0',
  },
}))(Dialog);

export default LandingModalDialog;
